var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isSummary ? _c('r-modal-container', {
    attrs: {
      "dialog": true,
      "icon": _vm.message.critical === 'CRITICAL' ? 'emergency' : 'warning',
      "iconColor": _vm.message.critical === 'CRITICAL' ? 'fargo' : 'lebowski',
      "iconSize": "56",
      "title": "Произошло критическое событие",
      "headerPaddingBottom": 16
    },
    scopedSlots: _vm._u([{
      key: "controls",
      fn: function () {
        return [_c('r-row', {
          attrs: {
            "gap-hidden": ""
          }
        }, [_c('r-col', {
          attrs: {
            "isFullWidth": ""
          }
        }, [_vm.message.target ? _c('r-button', {
          attrs: {
            "title": "Перейти к событию",
            "width": "wide"
          },
          on: {
            "click": function ($event) {
              return _vm.onTarget();
            }
          }
        }) : _c('r-button', {
          attrs: {
            "title": "Понятно",
            "width": "wide"
          },
          on: {
            "click": function ($event) {
              return _vm.onClose();
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }], null, false, 3758116967)
  }, [_c('div', {
    staticClass: "feta metropolis--text mb-6"
  }, [_vm._v(" " + _vm._s(_vm.message.message || 'Наименование критического события не указано') + " ")]), _vm.message.target ? _c('div', {
    staticClass: "parmigiano troy--text"
  }, [_vm._v(" Необходимо срочно перейти к событию и следовать инструкциям. ")]) : _vm._e()]) : _c('r-modal-container', {
    attrs: {
      "dialog": true,
      "icon": "emergency",
      "iconColor": "fargo",
      "iconSize": "56",
      "title": "У вас есть непрочитанные оповещения",
      "headerPaddingBottom": 16
    },
    scopedSlots: _vm._u([{
      key: "controls",
      fn: function () {
        return [_c('r-row', {
          attrs: {
            "gap-hidden": ""
          }
        }, [_c('r-col', {
          attrs: {
            "isFullWidth": ""
          }
        }, [_c('r-button', {
          attrs: {
            "title": "Понятно",
            "width": "wide"
          },
          on: {
            "click": function ($event) {
              return _vm.onClose();
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "feta metropolis--text mb-6"
  }, [_vm._v(" У вас " + _vm._s(_vm.notificationCount) + " в панели оповещений. ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }